import React, { Fragment, Component } from "react";
import styled, { keyframes } from "styled-components";
import FaCheck from "react-icons/lib/fa/check";
import FaInfoCircle from "react-icons/lib/fa/info-circle";
import { RandomDelayedLetter } from "../../containers/Transitions";
import ShadowHashlink from "../../containers/ShadowHashlink";
import { ResponsiveImage } from "../../containers/ProgressiveHelpers";

const Section = styled.div`
  padding: 7.5em 2.5em 2.5em;
  box-sizing: border-box;
  display: flex;
  position: relative;
  @media (min-width: 975px) {
    padding: 7.5em;
    background: url(${props => props.src});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: left;
  }
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

const Subtitle = styled.h2`
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  font-size: 2em;
  color: #333333;
  text-align: center;
`;

const ServicesList = styled.ul`
  font-family: "Raleway", sans-serif;
  font-size: 1.5em;
  color: rgb(115, 126, 255);
`;

const UnstyledListItem = styled.li`
  margin: 0.75em;
  list-style: none;
`;

const ListItemContent = styled.span`
  color: rgb(66, 61, 80);
  font-size: 0.75em;
`;

const CheckbarItem = ({ children }) => (
  <UnstyledListItem>
    <RandomDelayedLetter>
      <FaCheck />
    </RandomDelayedLetter>{" "}
    <ListItemContent>{children}</ListItemContent>
  </UnstyledListItem>
);

const Align = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 2.5em;

  @media (max-width: 540px) {
    justify-content: center;
  }
`;

export const Button = styled.a`
  all: initial;
  border-radius: 2.5em;
  border-color: rgba(153, 128, 214, 0.75);
  border-width: 0.275em;
  display: inline-flex;
  background-color: aliceblue;
  height: 2.5em;
  font-family: "Raleway", sans-serif;
  font-weight: 500;
  background: linear-gradient(30deg, rgb(87, 124, 255), rgb(111, 54, 255));
  color: white;
  justify-content: space-around;
  align-items: center;
  padding: 0.5em 2em 0.5em 2em;
  border-style: solid;
  position: relative;
  z-index: 0;
  transition: opacity 1s;
  cursor: pointer;
  transition: transform 0.5s;
  font-size: inherit;
  &:after {
    background: linear-gradient(30deg, rgb(111, 54, 255), rgb(87, 124, 255));
    border-radius: 2.5em;
    opacity: 0;
    width: 100%;
    height: 100%;
    content: "";
    position: absolute;
    z-index: -1;
    transition: opacity 0.5s;
  }

  &:hover:after {
    opacity: 1;
  }

  &:hover {
    transform: scale(0.95);
  }

  @media (max-width: 540px) {
    font-size: 1.25em;
  }
`;

export default ({ cms }) => (
  <ResponsiveImage path={cms["services-section-background-image"]}>
    <Section>
      <ShadowHashlink offset="-25%" id="leistungen" />
      <Content>
        <Subtitle children={cms["services-section-top-title"]} />
        <ServicesList>
          {cms["services-section-checkmark-items"].map((item, index) => (
            <CheckbarItem children={item} key={index} />
          ))}
        </ServicesList>
        <Subtitle children={cms["services-section-bottom-title"]} />
        <Align>
          <Button href="/mehr-erfahren">
            <FaInfoCircle
              style={{ paddingRight: "0.5em", fontSize: "1.5em" }}
            />
            <span>Mehr erfahren</span>
          </Button>
        </Align>
      </Content>
    </Section>
  </ResponsiveImage>
);



// WEBPACK FOOTER //
// /opt/build/repo/src/pages/Landing/ServicesSection.js